import React from "react";
import moment from "moment";
import convert from "convert-units";
import _ from "lodash";
import NavigationComponent from "../components/NavigationComponent";
import RangeContainerComponent from "../body-measurements/RangeContainerComponent";
import GraphComponent from "../readiness/GraphComponent";
import { RPEList } from "../session-rpe/RPEList";
import { DATE_FORMATS } from "../../../../constants";
import {
  getLabels,
  readyChartData,
  mapUtcToDatePicker,
  filterUnsetValues,
  sortStatsByDate,
  filterStatsbyDateRange,
} from "../../../../utils/daily-stats";
import { AthleteLinks } from "../../../../parts/athlete-links";
import { AthleteSelect } from "../../../../parts/inputs/athlete-select-new";
import getAvatarUrl from "../../../../utils/get-avatar-url";

const UNITS = {
  metric: "KG",
  imperial: "LB",
};
class Bodyweight extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.field = "bodyWeight";
    this.precision = 1;
    this.state = {
      currentAthlete: null,
      chartData: [],
      dateFrom: null,
      dateTo: null,
      quickDisabled: false,
      rangeSelector: {
        type: "months",
        value: 6,
      }, // in Weeks format
      statsData: [],
      hoveredDate: "",
      measureSelected: "",
      unitSelected: UNITS[context.locals.activeUser.units],
      comesFromBodyComp: props.comesFromBodyComp,
      sortedRecent: true,
      sortedTableData: null,
    };

    this.updateState = this.updateState.bind(this);
    this.updateHoveredStat = this.updateHoveredStat.bind(this);
    this.getDateFirstEntry = this.getDateFirstEntry.bind(this);
    this.sortList = this.sortList.bind(this);
  }

  componentDidMount() {
    const { value, type } = this.state.rangeSelector;
    const { unitSelected } = this.state;
    const athleteId = this.context.locals.athlete
      ? this.context.locals.athlete._id
      : this.context.locals.activeUser._id;
    // sorting most recent to oldest
    const stats = sortStatsByDate(
      filterUnsetValues(this.context.locals.dailyStats, this.field)
    );
    let convertedList =
      unitSelected === "LB" ? this.convertToLb(stats, this.field) : stats;

    this.setState({
      currentAthlete: athleteId,
      dateFrom: moment(new Date(), DATE_FORMATS.DATE_DAY_FORMAT)
        .subtract(value, type)
        .format(DATE_FORMATS.DATE_PICKER_FORMAT),
      statsData: convertedList,
    });
  }

  componentDidUpdate(prevProps, prevState) {
    const { state } = this;
    const athleteId = this.context.locals.athlete
      ? this.context.locals.athlete._id
      : this.context.locals.activeUser._id;

    //if the athlete is changed
    if (athleteId !== state.currentAthlete) {
      //if the range date is not lifetime, we only update the athlete

      if (state.rangeSelector.type !== "lifetime") {
        this.setState({ currentAthlete: athleteId });
      } else {
        //if range date is lifetime we set a default range
        this.setState({
          currentAthlete: athleteId,
          dateFrom: moment("2015-12-31T07:57:45.121Z").format(
            DATE_FORMATS.DATE_PICKER_FORMAT
          ),
        });
      }
    }

    if (
      state.unitSelected &&
      prevState.unitSelected &&
      state.unitSelected !== prevState.unitSelected
    ) {
      const statsData = _.cloneDeep(state.statsData);
      let convertedList = [];
      if (state.unitSelected === "KG") {
        convertedList = this.convertToKg(statsData, this.field);
      } else if (state.unitSelected === "LB") {
        convertedList = this.convertToLb(statsData, this.field);
      }
      this.setState({
        statsData: convertedList,
      });
    }

    //change the stats state to update the render
    if (
      prevState.currentAthlete !== null &&
      state.currentAthlete !== athleteId
    ) {
      const stats = sortStatsByDate(
        filterUnsetValues(this.context.locals.dailyStats, this.field)
      );
      let convertedListWithNewAthlete =
        state.unitSelected === "LB"
          ? this.convertToLb(stats, this.field)
          : stats;
      this.setState({
        statsData: convertedListWithNewAthlete,
      });
    }
  }

  updateHoveredStat(date = "") {
    this.setState({ hoveredDate: date });
  }

  convertToKg(stats, field) {
    const statsCopy = _.cloneDeep(stats);
    const kgsArray = statsCopy.map((stat) => {
      const kgsValue = convert(stat[field]).from("lb").to("kg");
      stat[field] = kgsValue;
      return stat;
    });
    return kgsArray;
  }

  convertToLb(stats, field) {
    const statsCopy = _.cloneDeep(stats);
    const lbsArray = statsCopy.map((stat) => {
      const lbsValue = convert(stat[field]).from("kg").to("lb");
      stat[field] = lbsValue;
      return stat;
    });
    return lbsArray;
  }

  roundStats(stats, field, precision) {
    return stats.map((stat) => {
      stat[field] = _.round(stat[field], precision);
      return stat;
    });
  }

  calculateAvg(stats, field, precision) {
    const total = stats
      .map((stat) => stat[field])
      .reduce((prev, current) => prev + current, 0);

    const avg = _.round(total / stats.length, precision);
    return avg;
  }

  addChangeTolist(stats, field, precision) {
    // asumes the stats are sorted for recent to oldest
    const statsCopy = _.cloneDeep(stats);
    for (let i = stats.length - 1; i >= 0; i--) {
      if (i === statsCopy.length - 1) {
        statsCopy[i].change = 0;
      } else {
        statsCopy[i].change = _.round(
          statsCopy[i][field] - statsCopy[i + 1][field],
          precision
        );
      }
    }
    return statsCopy;
  }

  getDateFirstEntry() {
    const firstEntry = this.context.locals.dailyStats
      .sort((a, b) => new Date(a.date) - new Date(b.date))
      .find((stats) => stats.bodyWeight);
    return firstEntry.date;
  }

  updateState(state) {
    this.setState(state);
  }
  sortList(newState) {
    this.setState({
      ...this.state,
      sortedTableData: newState.dateFormattedData,
      sortedRecent: newState.sortedRecent,
    });
  }
  render() {
    const { locals } = this.context;
    const {
      query,
      pathname,
      dailyStats,
      activeUser,
      activeUserToRequest,
      athlete,
    } = locals;
    const {
      dateTo,
      dateFrom,
      hoveredDate,
      unitSelected: unit,
      statsData,
    } = this.state;

    const intensityMeasure =
      _.get(activeUserToRequest, "intensityMeasure", "rpe") === "rpe"
        ? "RPE"
        : "RiR";
    const isRiR = intensityMeasure === "RiR";

    // sorted most recent to oldest
    const listData = filterStatsbyDateRange({
      stats: statsData,
      dateTo,
      dateFrom,
    });
    const unitToLower = _.toLower(unit);
    const unitCapitalized = _.capitalize(unit);
    const avg = this.calculateAvg(listData, this.field, this.precision);
    const roundedList = this.roundStats(listData, this.field, this.precision);
    const headerRight = {
      name: "Average ",
      value: avg ? `${_.round(avg, 2)}${unitToLower}` : 0,
    };

    const [chartData, labels] = [
      readyChartData({ stats: roundedList, field: this.field }),
      getLabels(roundedList).reverse(),
    ];

    const colors = ["rgba(91, 197, 0, 1)"];
    const start = roundedList[roundedList.length - 1]
      ? roundedList[roundedList.length - 1][this.field]
      : 0;
    const end = roundedList[0] ? roundedList[0][this.field] : 0;
    const change = _.round(end - start, this.precision);

    // RPE List data
    const statsList = this.addChangeTolist(
      mapUtcToDatePicker({
        stats: listData,
        fieldToConvert: "utcDate",
        newField: "date",
      }),
      this.field,
      this.precision
    );

    const columnsData = [
      {
        name: "Date",
        field: "date",
        columnClass: "date",
        itemClass: "date",
      },
      {
        name: unit,
        field: this.field,
        columnClass: "bodyweight",
        itemClass: "bodyweight",
      },
      {
        name: "Change",
        field: "change",
        columnClass: "change",
        itemClass: "change",
        unit: unit,
      },
    ];

    const unitOptions = [
      { name: "Kg", unit: "KG", value: "kg" },
      { name: "Lb", unit: "LB", value: "lb" },
    ];

    const chartOptions = {
      showLine: true,
      ticks: [],
      axisY: {
        offset: 50,
        labelOffset: {
          x: 5,
          y: 5,
        },
        labelInterpolationFnc: (value) => value.toFixed(1),
      },
    };

    return (
      <main role="reports-wrapper">
        <div className="athlete-section-header only-show-mobile">
          <AthleteLinks
            athlete={athlete}
            pathName={pathname}
            classNames={"only-show-mobile"}
            query={query}
          />
          <div className="athlete-select dropdown-athlete">
            <div
              className="avatar"
              style={{
                backgroundImage: `url(${getAvatarUrl(locals?.athlete?._id)})`,
              }}
            />
            <AthleteSelect locals={locals} />
          </div>
        </div>
        <NavigationComponent
          query={query}
          pathName={pathname}
          text={"Calendar Day View"}
          intensityMeasure={intensityMeasure}
          isRiR={isRiR}
          classNames="mobile-hidden"
        />
        <article id="bodyweight" role="report-content" security="">
          <RangeContainerComponent
            {...this.state}
            key={1}
            updateState={(state) => {
              this.updateState({
                ...state,
                sortedTableData: null,
              });
            }}
            getDateFirstEntry={this.getDateFirstEntry}
            unitOptions={unitOptions}
            reportSelected="Bodyweight"
            athleteId={locals?.athlete?._id}
            locals={locals}
          />

          <GraphComponent
            bodyMeasurement={true}
            dateTo={dateTo}
            dateFrom={dateFrom}
            series={chartData}
            labels={labels}
            chartName={unit}
            displayLeyend={false}
            colors={colors}
            areaOpacity={0.3}
            updateHoveredStat={this.updateHoveredStat}
            chartOptions={chartOptions}
            headerRight={headerRight}
            tooltipUnit={unitCapitalized}
          />
          <div className="bar-container">
            <div>
              <span>
                <b>
                  {start} {unitCapitalized}
                </b>
              </span>

              <h4>Start</h4>
            </div>
            <div data-middle="true">
              <span>
                <b>
                  {end} {unitCapitalized}
                </b>
              </span>

              <h4>End</h4>
            </div>
            <div>
              <span>
                <b>
                  {change} {unitCapitalized}
                </b>
              </span>
              <h4>Change</h4>
            </div>
          </div>

          <RPEList
            dateFrom={this.state.dateFrom}
            dateTo={this.state.dateTo}
            list={this.state.sortedTableData || statsList}
            columnsData={columnsData}
            customClass={"bodyweight"}
            highlightedElem={hoveredDate}
            sortedRecent={this.state.sortedRecent}
            updateState={this.sortList}
          />
        </article>
      </main>
    );
  }
}

export default Bodyweight;
